import React from 'react';
import AlerteInfoBeta from './AlerteInfoBeta';
import AlertePremiereCnx from './AlertePremiereCnx';
import CardActualite from './CardActualite';
import CardAG from './CardAG';
import CardCopro from './CardCopro';
import CardInfos from './CardInfos';
import CardSyndic from './CardSyndic';
import CardEcourrier from '../MesInfos/CardEcourrier';
// import CardLRE from '../MesInfos/CardLRE';
import CardPrelevement from '../MesInfos/Prelevement/CardPrelevement';


const Accueil = () => (
    <div className="Accueil">
        {/* <AlerteInfoBeta /> */}
        <AlertePremiereCnx />
        <div className="row">
            <div className="col-12 col-lg-6 col-xl-4">
                <CardSyndic />
                <CardCopro />
            </div>
            <div className="col-12 col-lg-6 col-xl-4">
                <CardActualite />
            </div>
            <div className="col-12 col-lg-6 col-xl-4">
                <CardInfos />
                <CardAG />
                <CardPrelevement Accueil />
                <CardEcourrier Accueil />
                {/* <CardLRE Accueil /> */}
            </div>
        </div>
    </div>
);

export default Accueil;



// WEBPACK FOOTER //
// ./src/components/Accueil/index.js